export const professionalsList = [
    'Therapists', 'Neurodevelopmental Specialists',
    'Dentists', 'Odontologists', 'Patient Assistants', 'Psychologists',
    'Nutritionists', 'Physiotherapists', 'Respiratory Therapists', 'Speech Therapists', 'Electrocardiography'
]

export const PaymentMethod = [
    ['cash', 'CASH'],
    ['bank', 'BANK'],

]

export const Currency = [
    // ['eur', 'EUR'],
    // ['inr', 'INR'],
    ['usd', 'USD'],
    ['crc', 'CRC']
]

export const getTranslatedOptions = (items, t, category) => {
    return items.map(item => ({
        value: item[0],
        label: t(`${category}.${item[0]}`, { defaultValue: item[1] }),
    }));
};
